import { NavLink as NavLinkBase } from 'react-router-dom'
import { Tooltip } from '@outbound-ai/ursa'
import styled from 'styled-components'

// types & utils
import type { LinkProps } from 'react-router-dom'
import { PositionEnum } from 'types/cssTypes'
interface IProps extends LinkProps {
  children: JSX.Element
  overlay: JSX.Element | string

  arrowPosition?: number
  tooltipTransform?: ITooltipTransform
}

interface ITooltipTransform {
  x: string
  y?: string
}

export const NavLinkWithTooltip = ({ children, to, overlay, arrowPosition, tooltipTransform, ...props }: IProps) => {
  return (
    <Div>
      <NavLinkBase to={to} {...props}>
        {/* <OverlayTrigger delay={{ show: 250, hide: 400 }} overlay={<StyledTooltip>{overlay}</StyledTooltip>}>
          <div>{children}</div>
        </OverlayTrigger> */}
        <Tooltip
          tooltipText={overlay}
          position={PositionEnum.top}
          positionTooltipArrow={arrowPosition || 15}
          tooltipStyles={{
            transform: tooltipTransform?.x || ' translateX(-25%)',
            width: '15rem',
          }}
        >
          <div>{children}</div>
        </Tooltip>
      </NavLinkBase>
    </Div>
  )
}

const Div = styled.div`
  height: 100%;
  a {
    height: 100%;
    font-weight: ${({ theme }) => theme.fontWeight.medium};
  }
  .tooltip-container {
    white-space: break-spaces;
  }
`

// const StyledTooltip = styled(Tooltip)`
//   &.show {
//     opacity: 1;
//   }

//   .tooltip-inner {
//     color: ${({ theme }) => theme.colors.primary.darker};
//     ${({ theme }) => theme.typography.xs.normal};
//     padding: 0.5rem;
//     background-color: #f2f2f2;
//   }

//   .tooltip-arrow::before {
//     border-top-color: #f2f2f2;
//   }
// `
